import React from "react";
import compass from "../../assets/images/icons/compass.svg";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

const BlueToolTip = withStyles(theme => ({
  tooltip: {
    backgroundColor: "#0016C7;",
    fontFamily: "Work Sans, sans",
    fontWeight: 600,
    fontSize: 12,
    letterSpacing: 0.5,
    padding: 10
  }
}))(Tooltip);

const Locate = props => {
  return (
    <BlueToolTip title="SHOW CURRENT LOCATION" placement="right" arrow>
      <button
        className="locate"
        onClick={() => {
          props.onLocationUpdate();
        }}
      >
        <img src={compass} alt="Target icon" />
      </button>
    </BlueToolTip>
  );
};

export default Locate;
